import { render, staticRenderFns } from "./GlNetworkTraffic.vue?vue&type=template&id=0baa6091&scoped=true&"
import script from "./GlNetworkTraffic.vue?vue&type=script&lang=js&"
export * from "./GlNetworkTraffic.vue?vue&type=script&lang=js&"
import style0 from "./GlNetworkTraffic.vue?vue&type=style&index=0&id=0baa6091&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0baa6091",
  null
  
)

export default component.exports